<template>
  <section class="section-login">
    <div class="login">
      <div class="login__form login__form--animate">
        <form @submit.prevent="askNewPassword()" class="form">
          <h2 class="heading-secondary">exopera 2.0</h2>
          <span style='font-size:1.65rem'>{{ $t('login.reset-password.title') }}</span>
          <Entry required typeField='password' v-model="password" :autoSave="true" :maskOnValue='hasToBeAValidPassword' indicator="form.newPassword"></Entry>
          <Entry required typeField='password' v-model="confirmPassword" :autoSave="true" :hasToCompare="true" :compareValue='hasToBeAMatchPassword(password,confirmPassword)' indicator="form.confirmPassword"></Entry>

          <div class="forgot-password__footer">
            <button class="popup__link u-pointer" type="button" @click='cancel'>{{ $t('login.retrieve-password.cancelAction') }}</button>
            <button class="popup__link u-pointer" type="submit">{{ $t('login.reset-password.confirmAction') }}</button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import Entry from '../components/Entry'
import { formMixin } from '../components/Mixins/Form'
import { toastMixin } from '../components/Mixins/Toast'
import { HTTP_CLIENT } from '../axios-wrapper'

export default {
  data: function () {
    return {
      password: '',
      confirmPassword: ''
    }
  },
  components: {
    Entry
  },
  mixins: [formMixin, toastMixin],
  methods: {
    async askNewPassword () {
      console.log(this.$route.query.id, this.$route.query.tokenReset, this.password, this.confirmPassword)

      if (this.password && this.confirmPassword && !this.$el.querySelectorAll('[data-entry-not-valid]').length) {
        try {
          await HTTP_CLIENT.post(`auth/reset`, {
            id: this.$route.query.id,
            tokenReset: this.$route.query.tokenReset,
            password: this.password,
            verifyPassword: this.confirmPassword
          })
          this.sendSuccessToast(this.$t('feedback-ok.user.reset-password', { password: this.password }))
          this.$router.push('login')
        } catch (err) { console.log(err) }
      }
    },
    cancel () {
      this.$router.push('login')
    }
  }
}
</script>
